import type { ColumnSortValue } from '../DataTable.types'
import { isBlankSortValue } from './isBlankSortValue'

export function compareColumnSortValues(
  left: ColumnSortValue,
  right: ColumnSortValue
): number {
  if (isBlankSortValue(left) || isBlankSortValue(right)) {
    return Number(isBlankSortValue(left)) - Number(isBlankSortValue(right))
  }
  if (typeof left === 'number' && typeof right === 'number') {
    return left - right
  }
  if (typeof left === 'boolean' && typeof right === 'boolean') {
    return Number(right) - Number(left)
  }
  return String(left).localeCompare(String(right), undefined, {
    numeric: true,
    sensitivity: 'base',
  })
}
